import React from "react";
import "./InvoiceSkeleton.css"; // import your skeleton CSS here

export const InvoiceSkeleton = () => {
  return (
    <div className="card border-0 shadow-sm p-4">
      {/* Logo */}
      <div className="text-center mb-3">
        <div className="skeleton skeleton-text-lg" style={{ width: "180px", height: "28px", margin: "auto" }}></div>
      </div>

      <hr />

      {/* Top Info */}
      <div className="row mt-3 mb-4">
        <div className="col-md-6">
          <div className="skeleton skeleton-text-sm mb-2"></div>
          <div className="skeleton skeleton-text-sm mb-2"></div>
          <div className="skeleton skeleton-text-sm"></div>
        </div>

        <div className="col-md-6 text-md-end mt-3 mt-md-0">
          <div className="skeleton skeleton-text-sm mb-2"></div>
          <div className="skeleton skeleton-text-sm"></div>
        </div>
      </div>

      {/* Invoice Summary */}
      <h6 className="fw-bold mt-4 mb-3">Invoice Summary</h6>
      <div className="table-responsive">
        <table className="table table-borderless">
          <tbody>
            {[...Array(3)].map((_, i) => (
              <tr key={i}>
                <td><div className="skeleton skeleton-text-sm"></div></td>
                <td className="text-center"><div className="skeleton skeleton-text-sm"></div></td>
                <td className="text-end"><div className="skeleton skeleton-text-sm"></div></td>
                <td className="text-end"><div className="skeleton skeleton-text-sm"></div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Payments Table */}
      <h6 className="fw-bold mt-4 mb-2">Payments</h6>
      <div className="table-responsive">
        <table className="table table-borderless">
          <tbody>
            {[...Array(2)].map((_, i) => (
              <tr key={i}>
                <td><div className="skeleton skeleton-text-sm"></div></td>
                <td className="text-center"><div className="skeleton skeleton-text-sm"></div></td>
                <td className="text-center"><div className="skeleton skeleton-text-sm"></div></td>
                <td className="text-end"><div className="skeleton skeleton-text-sm"></div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Payment Instructions */}
      <h6 className="fw-bold mt-4 mb-2"><div className="skeleton skeleton-text-sm"></div></h6>
      <ol className="small text-muted ps-3">
        {[...Array(2)].map((_, i) => (
          <li key={i} className="mb-2">
            <div className="skeleton skeleton-text-sm"></div>
          </li>
        ))}
      </ol>
    </div>
  );
};
